import React from 'react';
import PropTypes from 'prop-types';
import { Columns, Level, Button, Card, Table } from '@selfdetermine/react-elements';
import { Form } from '@selfdetermine/react-forms';
import { useQuery, useMutation } from '@selfdetermine/react-hooks';
import { gql } from '@selfdetermine/graphql';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    query {\n      viewer {\n        banks {\n          id\n          name\n          phoneNumber\n          street1\n          street2\n          city\n          state\n          postalCode\n        }\n      }\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      query Bank($id: ID!) {\n        viewer {\n          bank(id: $id) {\n            id\n            name\n            phoneNumber\n            street1\n            street2\n            city\n            state\n            postalCode\n          }\n        }\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    mutation($bank: UpdateBankInput) {\n      updateBank(bank: $bank) {\n        id\n      }\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    mutation($bank: NewBankInput!) {\n      addBank(bank: $bank) {\n        id\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var useCreate = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(bank) {
    return mutate({
      variables: {
        bank: bank
      }
    });
  };

  return [create, meta];
};

var useUpdate = function useUpdate() {
  var _useMutation3 = useMutation(gql(_templateObject2())),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      mutate = _useMutation4[0],
      meta = _useMutation4[1];

  var update = function update(bank) {
    return mutate({
      variables: {
        bank: bank
      }
    });
  };

  return [update, meta];
};

var useBank = function useBank() {
  var _data$viewer;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref.id;

  var _useQuery = useQuery(gql(_templateObject3()), {
    variables: {
      id: id
    }
  }),
      data = _useQuery.data,
      meta = _objectWithoutProperties(_useQuery, ["data"]);

  return [data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.bank, meta];
};
var useBanks = function useBanks() {
  var _data$viewer2;

  var _useQuery2 = useQuery(gql(_templateObject4())),
      data = _useQuery2.data,
      meta = _objectWithoutProperties(_useQuery2, ["data"]);

  return [(data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : _data$viewer2.banks) || [], meta];
};
var BankForm = function BankForm(_ref2) {
  var onDone = _ref2.onDone,
      onError = _ref2.onError,
      onCancel = _ref2.onCancel,
      defaultValues = _ref2.defaultValues;

  var _useCreate = useCreate(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var _useUpdate = useUpdate(),
      _useUpdate2 = _slicedToArray(_useUpdate, 2),
      update = _useUpdate2[0],
      updateMeta = _useUpdate2[1];

  var isCreate = !(defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.id);
  var isLoading = createMeta.loading || updateMeta.loading;
  var error = createMeta.error || updateMeta.error;
  return /*#__PURE__*/React.createElement(Form, {
    loading: isLoading,
    error: error,
    defaultValues: defaultValues,
    onSubmit: /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!isCreate) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return create(form);

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return update(_objectSpread2({
                  id: defaultValues.id
                }, form));

              case 8:
                if (typeof onDone === "function") {
                  onDone();
                }

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                if (typeof onError === "function") {
                  onError(_context.t0);
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/React.createElement(Form.Input, {
    name: "name",
    label: "Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "phoneNumber",
    label: "Phone Number",
    type: "phone"
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "street1",
    label: "Address 1",
    type: "text"
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "street2",
    label: "Address 2",
    type: "text"
  }), /*#__PURE__*/React.createElement(Columns, null, /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "city",
    label: "City",
    type: "text"
  })), /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "state",
    label: "State",
    type: "text"
  })), /*#__PURE__*/React.createElement(Columns.Column, null, /*#__PURE__*/React.createElement(Form.Input, {
    name: "postalCode",
    label: "Zip Code",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, {
    type: "cancel",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, null, isCreate ? "Create Bank" : "Update Bank")))));
};
BankForm.propTypes = {
  onDone: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  defaultValues: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  })
};
var BankCard = function BankCard(_ref4) {
  var bank = _ref4.bank,
      children = _ref4.children;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    title: (bank === null || bank === void 0 ? void 0 : bank.name) || "Unknown Name"
  }, children));
};
BankCard.propTypes = {
  bank: PropTypes.shape({
    name: PropTypes.string,
    street1: PropTypes.string,
    street2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    phoneNumber: PropTypes.string
  }).isRequired,
  children: PropTypes.node
};

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n    mutation($counsel: UpdateCounselInput) {\n      updateCounsel(counsel: $counsel) {\n        name\n      }\n    }\n  "]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  mutation($counsel: NewCounselInput) {\n    addCounsel(counsel: $counsel) {\n      name\n    }\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  query {\n    viewer {\n      counsels {\n        value: id\n        label: name\n      }\n    }\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  query {\n    viewer {\n      counsels {\n        id\n        name\n      }\n    }\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var COUNSEL_VIEWER = gql(_templateObject$1());
var COUNSEL_SELECTOR = gql(_templateObject2$1());
var ADD_COUNSEL_MUTATION = gql(_templateObject3$1());
var useAddCounsel = function useAddCounsel() {
  var _useMutation = useMutation(ADD_COUNSEL_MUTATION),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var addCounsel = function addCounsel(counsel) {
    return mutate({
      variables: {
        counsel: counsel
      },
      refetchQueries: [{
        query: COUNSEL_VIEWER
      }]
    });
  };

  return [addCounsel, meta];
};
var useUpdateCounsel = function useUpdateCounsel() {
  var _useMutation3 = useMutation(gql(_templateObject4$1())),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      mutate = _useMutation4[0],
      meta = _useMutation4[1];

  var update = function update(counsel) {
    return mutate({
      variables: {
        counsel: counsel
      }
    });
  };

  return [update, meta];
};
var useCounselList = function useCounselList() {
  var _data$viewer;

  var _useQuery = useQuery(COUNSEL_VIEWER),
      data = _useQuery.data,
      meta = _objectWithoutProperties(_useQuery, ["data"]);

  return [(data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.counsels) || [], meta];
};
var CounselForm = function CounselForm(_ref) {
  var onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel,
      defaultValues = _ref.defaultValues;

  var _useAddCounsel = useAddCounsel(),
      _useAddCounsel2 = _slicedToArray(_useAddCounsel, 2),
      addCounsel = _useAddCounsel2[0],
      addCounselMeta = _useAddCounsel2[1];

  var _useUpdateCounsel = useUpdateCounsel(),
      _useUpdateCounsel2 = _slicedToArray(_useUpdateCounsel, 2),
      updateCounsel = _useUpdateCounsel2[0],
      updateCounselMeta = _useUpdateCounsel2[1];

  var isCreate = !(defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.id);
  return /*#__PURE__*/React.createElement(Form, {
    loading: isCreate ? addCounselMeta.loading : updateCounselMeta.loading,
    error: isCreate ? addCounselMeta.error : updateCounselMeta.error,
    defaultValues: defaultValues,
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!isCreate) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return addCounsel(form);

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return updateCounsel(_objectSpread2({
                  id: defaultValues.id
                }, form));

              case 8:
                if (typeof onDone === "function") {
                  onDone();
                }

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                if (typeof onError === "function") {
                  onError(_context.t0);
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/React.createElement(Form.Input, {
    label: "Counsel's Name",
    help: "Full name of the lawyer or firm",
    name: "name"
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, {
    type: "cancel",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, null, isCreate ? "Create Counsel" : "Update Counsel")))));
};
var CounselTable = function CounselTable(_ref3) {
  var onSelect = _ref3.onSelect;

  var _useCounselList = useCounselList(),
      _useCounselList2 = _slicedToArray(_useCounselList, 2),
      counsels = _useCounselList2[0],
      counselListMeta = _useCounselList2[1];

  if (counselListMeta.loading) return null;
  return /*#__PURE__*/React.createElement(Table, {
    fullwidth: true,
    columns: [{
      id: "name",
      displayLabel: "Name"
    }]
  }, counsels.map(function (c) {
    return /*#__PURE__*/React.createElement(Table.Row, {
      key: c.id,
      renderCellContent: function renderCellContent(column) {
        return c[column.id];
      },
      onClick: function onClick() {
        return typeof onSelect === "function" ? onSelect(c) : null;
      }
    });
  }));
};
CounselTable.propTypes = {
  onSelect: PropTypes.func
};
CounselForm.propTypes = {
  onDone: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  defaultValues: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  })
};

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n    query {\n      viewer {\n        judges {\n          id\n          name\n        }\n      }\n    }\n  "]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n      query Judge($id: ID!) {\n        viewer {\n          judge(id: $id) {\n            id\n            name\n          }\n        }\n      }\n    "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n    mutation($judge: UpdateJudgeInput) {\n      updateJudge(judge: $judge) {\n        id\n        name\n      }\n    }\n  "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n    mutation($judge: NewJudgeInput) {\n      addJudge(judge: $judge) {\n        id\n        name\n      }\n    }\n  "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var useCreate$1 = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject$2())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(judge) {
    return mutate({
      variables: {
        judge: judge
      }
    });
  };

  return [create, meta];
};

var useUpdate$1 = function useUpdate() {
  var _useMutation3 = useMutation(gql(_templateObject2$2())),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      mutate = _useMutation4[0],
      meta = _useMutation4[1];

  var update = function update(judge) {
    return mutate({
      variables: {
        judge: judge
      }
    });
  };

  return [update, meta];
};

var useJudge = function useJudge() {
  var _data$viewer;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref.id;

  var _useQuery = useQuery(gql(_templateObject3$2()), {
    variables: {
      id: id
    }
  }),
      data = _useQuery.data,
      meta = _objectWithoutProperties(_useQuery, ["data"]);

  return [data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.judge, meta];
};
var useJudges = function useJudges() {
  var _data$viewer2;

  var _useQuery2 = useQuery(gql(_templateObject4$2())),
      data = _useQuery2.data,
      meta = _objectWithoutProperties(_useQuery2, ["data"]);

  return [(data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : _data$viewer2.judges) || [], meta];
};
var JudgeForm = function JudgeForm(_ref2) {
  var onDone = _ref2.onDone,
      onError = _ref2.onError,
      onCancel = _ref2.onCancel,
      defaultValues = _ref2.defaultValues;

  var _useCreate = useCreate$1(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var _useUpdate = useUpdate$1(),
      _useUpdate2 = _slicedToArray(_useUpdate, 2),
      update = _useUpdate2[0],
      updateMeta = _useUpdate2[1];

  var isCreate = !(defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.id);
  var isLoading = createMeta.loading || updateMeta.loading;
  var error = createMeta.error || updateMeta.error;
  return /*#__PURE__*/React.createElement(Form, {
    loading: isLoading,
    error: error,
    defaultValues: defaultValues,
    onSubmit: /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!isCreate) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return create(form);

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return update(_objectSpread2({
                  id: defaultValues.id
                }, form));

              case 8:
                if (typeof onDone === "function") {
                  onDone();
                }

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                if (typeof onError === "function") {
                  onError(_context.t0);
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/React.createElement(Form.Input, {
    label: "Judge's Name",
    name: "name"
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, {
    type: "cancel",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, null, isCreate ? "Create Judge" : "Update Judge")))));
};
JudgeForm.propTypes = {
  onDone: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  defaultValues: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  })
};
var JudgeCard = function JudgeCard(_ref4) {
  var judge = _ref4.judge,
      children = _objectWithoutProperties(_ref4, ["judge"]);

  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    title: judge.name || "Unknown"
  }, children));
};
JudgeCard.propTypes = {
  judge: PropTypes.shape({
    name: PropTypes.string
  }).isRequired
};

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n    query {\n      viewer {\n        officers {\n          id\n          name\n        }\n      }\n    }\n  "]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n      query Officer($id: ID!) {\n        viewer {\n          officer(id: $id) {\n            id\n            name\n          }\n        }\n      }\n    "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n    mutation($officer: UpdateOfficerInput) {\n      updateOfficer(officer: $officer) {\n        id\n        name\n      }\n    }\n  "]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n    mutation($officer: NewOfficerInput) {\n      addOfficer(officer: $officer) {\n        id\n        name\n      }\n    }\n  "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var useCreate$2 = function useCreate() {
  var _useMutation = useMutation(gql(_templateObject$3())),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var create = function create(officer) {
    return mutate({
      variables: {
        officer: officer
      }
    });
  };

  return [create, meta];
};

var useUpdate$2 = function useUpdate() {
  var _useMutation3 = useMutation(gql(_templateObject2$3())),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      mutate = _useMutation4[0],
      meta = _useMutation4[1];

  var update = function update(officer) {
    return mutate({
      variables: {
        officer: officer
      }
    });
  };

  return [update, meta];
};

var useOfficer = function useOfficer() {
  var _data$viewer;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      id = _ref.id;

  var _useQuery = useQuery(gql(_templateObject3$3()), {
    variables: {
      id: id
    }
  }),
      data = _useQuery.data,
      meta = _objectWithoutProperties(_useQuery, ["data"]);

  return [data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.officer, meta];
};
var useOfficers = function useOfficers() {
  var _data$viewer2;

  var _useQuery2 = useQuery(gql(_templateObject4$3())),
      data = _useQuery2.data,
      meta = _objectWithoutProperties(_useQuery2, ["data"]);

  return [(data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : _data$viewer2.officers) || [], meta];
};
var OfficerForm = function OfficerForm(_ref2) {
  var onDone = _ref2.onDone,
      onError = _ref2.onError,
      onCancel = _ref2.onCancel,
      defaultValues = _ref2.defaultValues;

  var _useCreate = useCreate$2(),
      _useCreate2 = _slicedToArray(_useCreate, 2),
      create = _useCreate2[0],
      createMeta = _useCreate2[1];

  var _useUpdate = useUpdate$2(),
      _useUpdate2 = _slicedToArray(_useUpdate, 2),
      update = _useUpdate2[0],
      updateMeta = _useUpdate2[1];

  var isCreate = !(defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.id);
  var isLoading = createMeta.loading || updateMeta.loading;
  var error = createMeta.error || updateMeta.error;
  return /*#__PURE__*/React.createElement(Form, {
    loading: isLoading,
    error: error,
    defaultValues: defaultValues,
    onSubmit: /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!isCreate) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return create(form);

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return update(_objectSpread2({
                  id: defaultValues.id
                }, form));

              case 8:
                if (typeof onDone === "function") {
                  onDone();
                }

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                if (typeof onError === "function") {
                  onError(_context.t0);
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/React.createElement(Form.Input, {
    label: "Officer's Name",
    name: "name"
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, {
    type: "cancel",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, null, isCreate ? "Create Officer" : "Update Officer")))));
};
OfficerForm.propTypes = {
  onDone: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  defaultValues: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  })
};
var OfficerCard = function OfficerCard(_ref4) {
  var officer = _ref4.officer,
      children = _objectWithoutProperties(_ref4, ["officer"]);

  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    title: officer.name || "Unknown"
  }, children));
};
OfficerCard.propTypes = {
  officer: PropTypes.shape({
    name: PropTypes.string
  }).isRequired
};

export { ADD_COUNSEL_MUTATION, BankCard, BankForm, COUNSEL_SELECTOR, COUNSEL_VIEWER, CounselForm, CounselTable, JudgeCard, JudgeForm, OfficerCard, OfficerForm, useAddCounsel, useBank, useBanks, useCounselList, useJudge, useJudges, useOfficer, useOfficers, useUpdateCounsel };
